const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const Search = {
	$searchInput: $('#site-search'),
	$searchResults: $('#search_results'),
	$suggestionsContainer: $('.js-quick-search-suggestions'),
	$searchDropdown: $('.js-search-dropdown'),
	$searchProducts: $('.js-quick-search-products'),
	$noSearchResults: $('.js-no-results'),
	$clearSearch: $('.js-clear-main-search'),
	$searchTerm: $('.js-search-term'),
	$searchLoader: $('.js-search-loader'),
	debounceTimer: null,
	categoryIcon: document.location.protocol + '//' + window.location.host + '/wp-content/themes/fws-eastern-tabletop/src/assets/svg/ico-folder.svg',
	categoryIconHtml: '',
	productIcon: document.location.protocol + '//' + window.location.host + '/wp-content/themes/fws-eastern-tabletop/src/assets/svg/ico-search.svg',
	productIconHtml: '',
	searchTerm: '',

	init: function() {
		const _this = this;
		this.initSearch();
		// get product SVG
		$.get(this.productIcon, function(data) {
			const svgElement = $(data).find('svg');
			_this.productIconHtml = $('<span>').addClass('quick-search__item-icon svg-icon').append(svgElement);
		}, 'xml');

		// get category SVG
		$.get(this.categoryIcon, function(data) {
			const svgElement = $(data).find('svg');
			_this.categoryIconHtml = $('<span>').addClass('quick-search__item-icon svg-icon').append(svgElement);
		}, 'xml');

		this.$clearSearch.on('click', function() {
			_this.$searchInput.val('');
			_this.$searchDropdown.removeClass('is-active');
			$(this).removeClass('is-active');
		});

		Global.escKey(_this.closeSearch.bind(_this));
		Global.clickOutsideContainer(Global.$domBody, _this.$searchDropdown, _this.$searchInput, _this.closeSearch.bind(_this));
	},

	initSearch: function() {
		const _this = this;
		$(document).ready(function() {
			_this.$searchInput.on('input', function() {
				_this.$searchDropdown.removeClass('is-active');
				_this.debounce($(this).val(), 300);
			});

			// enter event
			_this.$searchInput.on('keypress', function(e) {
				if (e.which === 13) {
					e.preventDefault();
					const searchValue = $(this).val().trim();
					if (searchValue.length >= 3) {
						window.location.href = window.fwsLocalized.siteUrl + '?s=' + encodeURIComponent(searchValue);
					}
				}
			});
		});
	},

	performSearch: function(query) {
		const _this = this;
		if (query.length < 3) {
			return;
		}

		$.ajax({
			url: window.fwsLocalized.ajaxUrl,
			method: 'POST',
			data: {
				action: 'search',
				query: query
			},
			dataType: 'json',
			beforeSend: function() {
				_this.$searchLoader.addClass('is-active');
				_this.hideNoResults();
				_this.$clearSearch.addClass('is-active');
			},
			success: function(data) {
				_this.searchTerm = query;
				_this.outputResults(data, query);
				_this.$searchDropdown.addClass('is-active');
			},
			complete: function() {
				_this.$searchLoader.removeClass('is-active');
				_this.$searchTerm.text('"' + _this.searchTerm +'"');
				$('.js-qs-link').attr('href', window.fwsLocalized.siteUrl + '?s=' + encodeURIComponent(_this.searchTerm));
			},
			error: function() {
				console.error('');
			}
		});
	},

	debounce: function(query, delay) {
		const _this = this;
		clearTimeout(this.debounceTimer);
		this.debounceTimer = setTimeout(() => _this.performSearch(query), delay);
	},

	outputResults: function(data) {
		this.$suggestionsContainer.html('');
		this.$searchProducts.html('');

		const productSuggestions = data?.data?.product_suggestions ?? [];
		const categorySuggestions = data?.data?.category_suggestions ?? [];
		const productsInfo = data?.data?.products_info ?? [];
		if (productSuggestions .length === 0 && categorySuggestions.length === 0 && productsInfo.length === 0) {
			this.showNoResults();
		} else {
			this.hideNoResults();
			this.renderSuggestions(productSuggestions, false);
			this.renderSuggestions(categorySuggestions, true);
			this.renderProductsInfo(productsInfo);
		}
	},

	showNoResults() {
		this.$noSearchResults.removeClass('hidden-element');
		this.$searchResults.addClass('hidden-element');
	},

	hideNoResults() {
		this.$noSearchResults.addClass('hidden-element');
		this.$searchResults.removeClass('hidden-element');
	},

	renderProductsInfo(productsInfo) {
		const _this = this;
		if (productsInfo && Object.keys(productsInfo).length > 0) {
			$.each(productsInfo, function(index, product) {
				const productItem = $('<div>').addClass('quick-search__product').append(
					$('<a>').addClass('quick-search__product-link').attr('href', product.url ?? '').append(
						$('<div>').addClass('quick-search__product-image').append(
							$('<img>').attr('src', product.image ?? '').attr('alt', product.title ?? '')
						),
						$('<div>').addClass('quick-search__product-info').append(
							$('<h3>').addClass('quick-search__product-title').text(product.title ?? ''),
							$('<ul>').addClass('quick-search__product-details')
						)
					)
				);

				if (product.sku) {
					productItem.find('.quick-search__product-details').append(
						$('<li>').text(product.sku ?? '')
					);
				}

				if (product.size) {
					productItem.find('.quick-search__product-details').append(
						$('<li>').text(product.size ?? '')
					);
				}

				if (product.options_text) {
					productItem.find('.quick-search__product-details').append(
						$('<li>').html($('<strong>').text(product.options_text))
					);
				}

				_this.$searchProducts.append(productItem);
			});
		}
	},

	renderSuggestions(suggestions, isCategory = false) {
		const _this = this;
		if (suggestions && suggestions.length > 0) {
			suggestions.forEach(function(suggestion) {
				let suggestionText = '';
				let linkHref = 'javascript:;';

				if (isCategory && typeof suggestion === 'object' && suggestion !== null) {
					suggestionText = suggestion.title || '';
					linkHref = suggestion.link || 'javascript:;';
				} else if (typeof suggestion === 'string') {
					suggestionText = suggestion;
					const encodedSuggestion = encodeURIComponent(suggestion);
					linkHref = `${window.fwsLocalized.siteUrl}?s=${encodedSuggestion}`;
				}

				let highlightedText = suggestionText;
				if (typeof suggestionText === 'string' && suggestionText.length > 0) {
					const regex = new RegExp('(' + _this.searchTerm + ')', 'gi');
					highlightedText = suggestionText.replace(regex, '<strong>$1</strong>');
				}

				const spanElement = $('<span>').html(highlightedText);

				let icon = '';
				if (isCategory && _this.categoryIconHtml !== '') {
					icon = _this.categoryIconHtml.clone();
				} else if (!isCategory && _this.productIconHtml !== '') {
					icon = _this.productIconHtml.clone();
				}

				const suggestionResult = $('<li>')
					.addClass('quick-search__item')
					.append(
						$('<a>')
							.addClass('quick-search__item-link')
							.attr('href', linkHref)
							.append(icon, spanElement)
					);

				_this.$suggestionsContainer.append(suggestionResult);
			});
		}
	},

	closeSearch() {
		const _this = this;
		_this.$searchDropdown.removeClass('is-active');
		_this.$searchInput.val('');
		this.$clearSearch.removeClass('is-active');
	}
};

export default Search;
